import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';

import useSettings, { IWebsiteConfigs } from 'store/settings';

type Props = {
  height?: string;
};

const SectionLoader: FC<Props> = ({ height }): JSX.Element => {
  const [
    {
      data: { meta = {} as IWebsiteConfigs },
    },
  ] = useSettings();

  return (
    <Box
      width="100%"
      height={height ? `${height}px` : '100%'}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {meta.logoUrl ? (
        <img src={meta.logoUrl} alt="LogoImage" data-testid="main-loader" />
      ) : (
        <CircularProgress size="51px" />
      )}
    </Box>
  );
};

export default SectionLoader;
